import React from 'react';
import { SvgIconProps, Theme, styled } from '@mui/material';
import { MUIStyledCommonProps } from '@mui/system';
import { SpinningLoading } from '../animations';
import { LoadingIcon } from '../sizes';
import { Primary } from '../color';

const Wrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export interface AutocompleteLoadingIndicatorProps extends SvgIconProps {
  WrapperProps?: MUIStyledCommonProps<Theme>;
}

export const AutocompleteLoadingIndicator = (props: AutocompleteLoadingIndicatorProps) => {
  const { WrapperProps, sx, ...rest } = props;

  return (
    <Wrapper {...WrapperProps}>
      <SpinningLoading
        {...rest}
        sx={{
          color: Primary.default.main,
          ...LoadingIcon,
          ...sx,
        }}
      />
    </Wrapper>
  );
};
